import React from 'react';
import { Link } from 'react-router-dom';

const AgConvergePreview = () => {
  return (
    <>
      {/* AgConverge Hero Section */}
      <section className="agconverge-section">
        <div className="agconverge-content">
          <h2 className="agconverge-title">
            The Spur AgConverge '26
          </h2>

          <p className="agconverge-subtitle">
            Where Innovation Meets the Farms
          </p>

          <div className="agconverge-details">
            <div className="agconverge-detail">
              <i className="far fa-calendar" />
              <span>Nov 17–18, 2026</span>
            </div>

            <div className="agconverge-detail">
              <i className="fas fa-map-marker-alt" />
              <span>Raising Nebraska, Grand Island</span>
            </div>
          </div>

          {/* Buttons are now inside the orange section */}
          <div className="agconverge-buttons">
            <a
              href="https://cvent.me/9E05M7"
              target="_blank"
              rel="noopener noreferrer"
              className="agconverge-btn primary"
            >
              Register Now
            </a>

            <Link
              to="/agconverge"
              className="agconverge-btn secondary"
            >
              AgConverge ‘26
            </Link>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <div className="container">
          <h2 className="video-section-title">
            See Spur in Action
          </h2>

          <p className="video-section-subtitle">
            Watch highlights from AgConverge '25 and learn what Spur
            Ventures is all about.
          </p>

          <div className="video-single">
            <div className="video-card">
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/qAeIpSJhDVg"
                  title="What is Spur Ventures?"
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>

              <div className="video-card-body">
                <span className="video-card-tag">
                  Event Recap
                </span>

                <h3 className="video-card-title">
                  AgConverge '25 Highlights
                </h3>

                <p className="video-card-desc">
                  A look back at the inaugural Spur AgConverge — where
                  farmers, startups, researchers, and industry leaders
                  converged in Gothenburg, Nebraska.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgConvergePreview;